import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=e8bc9a02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bc9a02"]])

export default __exports__